import React from "react";
import Team1 from "../media/team-1.jpeg";
import Team2 from "../media/team-2.jpeg";
import Team3 from "../media/team-3.jpeg";
import Team4 from "../media/team-4.jpeg";
import Team5 from "../media/team-5.png";
import Team6 from "../media/team-6.png";

function Team() {
  return (
    <div className="border bg-second">
      <div className="md:container md:mx-auto flex flex-col items-center justify-center px-16">
        <h1 className=" text-white mt-16 uppercase font-bold text-2xl inline-block border-b border-white">
          əməkdaşlar
        </h1>
        <div className="cards grid md:flex-nowrap sm:flex-wrap justify-center items-center md:grid-cols-3 sm:grid-cols-2 gap-4 text-white my-16">
          <div className="card  bg-second text-center flex flex-col rounded-2xl ">
            <img className="p-5" src={Team1} alt="" />
            <div className="header flex flex-col gap-y-3">
              <h1 className="text-lg">Adil Mehdiyev</h1>
              <p className="text-sm">Inşaat mühəndisi</p>
              <p className="mb-3 text-sm">İş təcrübəsi: 2 il</p>
            </div>
          </div>

          <div className="card  bg-second text-center flex flex-col rounded-2xl ">
            <img className="p-5" src={Team2} alt="" />
            <div className="header flex flex-col gap-y-3">
              <h1 className="text-lg">Rafiq Rzayev</h1>
              <p className="text-sm">Inşaat mühəndisi</p>
              <p className="mb-3 text-sm">İş təcrübəsi: 15 il</p>
            </div>
          </div>

          <div className="card  bg-second text-center flex flex-col rounded-2xl">
            <img className="p-5" src={Team3} alt="" />
            <div className="header flex flex-col gap-y-3">
              <h1 className="text-lg">Zaur Mikayılov</h1>
              <p className="text-sm">Geodeziya üzrə mütəxəssis</p>
              <p className="mb-3 text-sm">İş təcrübəsi: 5 il</p>
            </div>
          </div>

          <div className="card  bg-second text-center flex flex-col rounded-2xl">
            <img className="p-5" src={Team4} alt="" />
            <div className="header flex flex-col gap-y-3">
              <h1 className="text-lg">Rəşad İbrahimov</h1>
              <p className="text-sm">Geodeziya üzrə operator</p>
              <p className="mb-3 text-sm">İş təcrübəsi: 3 il</p>
            </div>
          </div>

          <div className="card  bg-second text-center flex flex-col rounded-2xl">
            <img className="p-5" src={Team5} alt="" />
            <div className="header flex flex-col gap-y-3">
              <h1 className="text-lg">Elnur Mehtiyev</h1>
              <p className="text-sm">Sahə rəisi</p>
              <p className="mb-3 text-sm">İş təcrübəsi: 1 il</p>
            </div>
          </div>

          <div className="card  bg-second text-center flex flex-col  rounded-2xl">
            <img className="p-5" src={Team6} alt="" />
            <div className="header flex flex-col gap-y-3">
              <h1 className="text-lg">Elnur Mehtiyev</h1>
              <p className="text-sm">Sahə rəisi</p>
              <p className="mb-3 text-sm">İş təcrübəsi: 1 il</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team;
